import axios from 'axios'

export default {
  callback (token) {
    return axios.get(`/api/kyc/cb/${token}`).then(r => r.data)
  },
  getDetails () {
    return axios.get(`/api/kyc`).then(r => r.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/kyc.js